import { render, staticRenderFns } from "./pictureList_text.vue?vue&type=template&id=c1987ac6&scoped=true&"
import script from "./pictureList_text.vue?vue&type=script&lang=js&"
export * from "./pictureList_text.vue?vue&type=script&lang=js&"
import style0 from "./pictureList_text.vue?vue&type=style&index=0&id=c1987ac6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1987ac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1987ac6')) {
      api.createRecord('c1987ac6', component.options)
    } else {
      api.reload('c1987ac6', component.options)
    }
    module.hot.accept("./pictureList_text.vue?vue&type=template&id=c1987ac6&scoped=true&", function () {
      api.rerender('c1987ac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/products_management/components/pictureList_text/pictureList_text.vue"
export default component.exports